module.exports = __webpack_public_path__ + "img/flow-icon-4.427f53b2.png";